import { HeidiVersion, type SubscriptionTier } from '@heidi/schema/ml-scribe';

export function isHeidi2OptInCreditUsageEnabled({
  isHeidi2OptInEnabled,
  heidiVersion,
}: {
  isHeidi2OptInEnabled: boolean;
  heidiVersion: HeidiVersion | null | undefined;
}): boolean {
  return isHeidi2OptInEnabled && heidiVersion === HeidiVersion.Value2;
}

/**
 * Credit-usage surfaces for an opt-in rollout user who has landed on Heidi 2.
 * `heidi_version === 2` alone is not enough — the opt-in flag is the rollout
 * switch. Shared by the side-nav popover, billing usage row, and launch gate.
 */
export function isCreditUsageSurfaceEnabled({
  isHeidi2OptInEnabled,
  heidiVersion,
}: {
  isHeidi2OptInEnabled: boolean;
  heidiVersion: HeidiVersion | null | undefined;
}): boolean {
  return isHeidi2OptInCreditUsageEnabled({ isHeidi2OptInEnabled, heidiVersion });
}

/** Opt-in credit usage on a resolved tier. Opt-in sees every tier. */
export function isCreditUsageSurfaceEligible({
  isHeidi2OptInEnabled,
  heidiVersion,
  newUserTier,
}: {
  isHeidi2OptInEnabled: boolean;
  heidiVersion: HeidiVersion | null | undefined;
  newUserTier: SubscriptionTier | null | undefined;
}): boolean {
  return (
    isCreditUsageSurfaceEnabled({ isHeidi2OptInEnabled, heidiVersion }) &&
    newUserTier != null
  );
}
